// extracted by mini-css-extract-plugin
export var button = "_70-7";
export var buttonRow = "_70-6";
export var fadeIn = "_70-1";
export var gradient = "_70-0";
export var panel = "_70-2";
export var panelIn = "_70-3";
export var subtitle = "_70-5";
export var title = "_70-4";